import { formatCurrency } from "../format/number";

// eslint-disable-next-line import/prefer-default-export
export const moneyFormat = (number, prefix = "$") => formatCurrency(parseFloat(number), prefix);
